


























































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import UploadExcel, {ExcelData} from "@/shared/components/UploadExcel/index.vue";
import {MAPPING_CREATE_REPORT_DELIVERY_EXCEL} from "@/shared/constant";
import cloneDeep from 'lodash/cloneDeep';
import {FieldReportDeliveryExcel} from "@/enums/fieldreportdeliveryexcel";
import InputTimeCustom from "@/shared/components/InputTimeCustom/index.vue";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";
import InputDateCustom from "@/shared/components/InputDateCustom/index.vue";
import {createReportDeliveryExcel} from "@/modules/reportdelivery/service";

const columns = [
    {
        title: 'STT',
        dataIndex: 'stt',
        key: 'stt',
        align: 'center',
        width: 50
    },
    {
        title: 'Mã vận đơn',
        dataIndex: 'ladingCode',
        key: 'ladingCode',
        align: 'center',
        scopedSlots: { customRender: "ladingCode" },
        width: 100
    },
    {
        title: 'Người nhận',
        dataIndex: 'receiver',
        key: 'receiver',
        align: 'center',
        scopedSlots: { customRender: "receiver" },
        width: 100
    },
    {
        title: 'Giờ báo phát',
        dataIndex: 'reportDeliveryTime',
        key: 'reportDeliveryTime',
        align: 'center',
        scopedSlots: { customRender: "reportDeliveryTime" },
        width: 100
    },
    {
        title: 'Ngày báo phát',
        dataIndex: 'reportDeliveryDate',
        key: 'reportDeliveryDate',
        align: 'center',
        scopedSlots: { customRender: "reportDeliveryDate" },
        width: 150
    },
    {
        title: 'Ghi chú',
        dataIndex: 'note',
        key: 'note',
        align: 'center',
        scopedSlots: { customRender: "note" },
        width: 100
    },
    {
        title: 'Xóa',
        dataIndex: 'ladingCode',
        key: 'action',
        align: 'center',
        scopedSlots: { customRender: "action" },
        width: 50
    },
];
const form = {
    reportDeliveries: [] as any
};
@Component({
    name: "ReportDeliveryExcel",
    components: {InputDateCustom, AInputCustom, InputTimeCustom, UploadExcel}
})
export default class extends mixins(CommonMixin) {
    columns = [...columns];
    form = cloneDeep(form);
    isSubmitting = false;
    async onSubmit() {
        if (!this.isValidForm()) return;
        try {
            this.isSubmitting = true;
            await createReportDeliveryExcel(this.form);
            this.form = cloneDeep(form);
            this.$message.success("Tạo báo phát thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Tạo báo phát thất bại");
        } finally {
            this.isSubmitting = false;
        }
    }

    isValidForm() {
        if (!this.form.reportDeliveries || !this.form?.reportDeliveries?.length) {
            this.$message.error("Vui lòng up excel để tạo báo phát");
            return false;
        }
        return true;
    }

    onSuccessUpload(excelData: ExcelData) {
        if (!this.isValidFileExcel(excelData.header)) return;
        this.form.reportDeliveries = [] as any;
        this.form.reportDeliveries = this.mapToJson(excelData.header, excelData.results);
        console.log(this.form);
    }

    isValidFileExcel(header) {
        if (!header || !Array.isArray(header) || header.length !== Object.keys(MAPPING_CREATE_REPORT_DELIVERY_EXCEL).length) {
            this.$message.error("File excel bị lỗi");
            return false;
        }
        for (let i = 0; i < header.length; i++) {
            if (!Object.keys(MAPPING_CREATE_REPORT_DELIVERY_EXCEL).includes(header[i])) {
                this.$message.error("File excel bị lỗi");
                return false;
            }
        }
        return true;
    }

    mapToJson(header: Array<string>, results: Array<any>) {
        const mapResults: any = [];
        results.forEach((item: any, index: number) => {
            const obj = {} as any;
            let reportDeliveryTime = "";
            let reportDeliveryDate = "";
            header.forEach((key: string) => {
                const trueKey = MAPPING_CREATE_REPORT_DELIVERY_EXCEL[key];
                if (trueKey === FieldReportDeliveryExcel.Hour) {
                    reportDeliveryTime += item[key];
                } else if (trueKey === FieldReportDeliveryExcel.Minute) {
                    reportDeliveryTime += `:${item[key]}`;
                } else if (trueKey === FieldReportDeliveryExcel.Day) {
                    reportDeliveryDate += item[key]
                } else if (trueKey === FieldReportDeliveryExcel.Month) {
                    reportDeliveryDate += `/${item[key]}`;
                } else if (trueKey === FieldReportDeliveryExcel.Year) {
                    reportDeliveryDate += `/${item[key]}`;
                } else if (trueKey) {
                    obj[trueKey] = item[key];
                }
            });
            obj['reportDeliveryTime'] = reportDeliveryTime;
            obj['reportDeliveryDate'] = reportDeliveryDate;
            mapResults.push({
                ...obj,
                stt: index + 1,
            })
        })
        return mapResults;
    }
    deleteLading(billLading: any) {
        const index = this.form.reportDeliveries.findIndex((lading: any) => billLading.ladingCode === lading.ladingCode);
        this.form.reportDeliveries.splice(index, 1);
    }
}
